export enum USER_SETTINGS {
    /**
     * @value Connection and contact email
     */
    ALTERNATE_EMAIL = 'USER_PROFILE_ALTERNATE_EMAIL',
    /**
     * @value Alternative language
     */
    ALTERNATIVE_LANGUAGE = 'USER_PROFILE_FALLBACK_LANGUAGE',
    /**
     * @value App Login Code
     */
    APP_LOGIN_CODE = 'USER_SETTINGS.APP_LOGIN_CODE',
    /**
     * @value Generate QR code
     */
    APP_LOGIN_GENERATE_QR_CODE = 'USER_SETTINGS.APP_LOGIN_GENERATE_QR_CODE',
    /**
     * @value Log in to the mobile app by scanning the QR code with a mobile device.
     */
    APP_LOGIN_SCAN_QR_CODE = 'USER_SETTINGS.APP_LOGIN_SCAN_QR_CODE',
    /**
     * @value Bell
     * @description Column header of a table used to enable notifications per notification type in-app
     */
    BELL_COLUMN_HEADER = 'NOTIFICATION.PREFERENCES.TABLE.BELL.COLUMN.HEADER',
    /**
     * @value Select / Deselect all
     * @description Label of a switch used to activate all notifications for a given device (in-app, email).
     */
    CHECK_ALL_ROW_LABEL = 'NOTIFICATION.PREFERENCES.TABLE.CHECK_ALL.ROW.LABEL',
    /**
     * @value Current password
     */
    CURRENT_PASSWORD = 'USER_PROFILE_CURRENT_PASSWORD',
    /**
     * @value Do not disturb
     * @description Header for the "do not disturb" option which suspends push notifications for the user inside the time slot they chose.
     */
    DO_NOT_DISTURB_HEADER = 'NOTIFICATION.PREFERENCES.DO_NOT_DISTURB.HEADER',
    /**
     * @value Receive email and mobile push notifications between the following times:
     * @description Label for the "do not disturb" option which suspends push notifications for the user inside the time slot they chose.
     */
    DO_NOT_DISTURB_LABEL = 'NOTIFICATION.PREFERENCES.DO_NOT_DISTURB.LABEL',
    /**
     * @value Email tracking
     * @description Title for section in notification settings page
     */
    EMAIL_TRACKING = 'USER_SETTINGS.EMAIL_TRACKING',
    /**
     * @value We measure when you open emails from your organization. You can change this choice at any time.
     * @description Helper text for the email pixel tracking checkbox in user notification settings
     */
    EMAIL_TRACKING_DESCRIPTION = 'USER_SETTINGS.EMAIL_TRACKING_DESCRIPTION',
    /**
     * @value Allow tracking when I open emails
     * @description Label for the email pixel tracking checkbox in user notification settings
     */
    EMAIL_TRACKING_LABEL = 'USER_SETTINGS.EMAIL_TRACKING_LABEL',
    /**
     * @value Receive email notifications according to the selection below.
     * Receive mobile push notifications according to your preferences in the mobile app.
     * @description Helper to describe the impact of activating email and mobile push notifications (NOTIFICATION.PREFERENCES.ENABLE.PUSH.LABEL).
     */
    ENABLE_PUSH_DESCRIPTION = 'NOTIFICATION.PREFERENCES.ENABLE.PUSH.DESCRIPTION',
    /**
     * @value Enable email and mobile push notifications
     * @description Used to activate push notifications (email and mobile).
     */
    ENABLE_PUSH_LABEL = 'NOTIFICATION.PREFERENCES.ENABLE.PUSH.LABEL',
    /**
     * @value Email sending frequency
     * @description Header to describe the section that allows user to receive email notifications immediately, or later via a daily summary.
     */
    FREQUENCY = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.HEADER',
    /**
     * @value Receive a summary of the latest notifications every day.
     * @description Option to receive notifications via a daily summary email, instead of immediately for each new one (helper).
     *
     */
    FREQUENCY_DAILY_SUMMARY_DESCRIPTION = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.DAILY_SUMMARY.DESCRIPTION',
    /**
     * @value Daily summary
     * @description Option to receive notifications via a daily summary email, instead of immediately for each new one (label).
     */
    FREQUENCY_DAILY_SUMMARY_LABEL = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.DAILY_SUMMARY.LABEL',
    /**
     * @value Receive an email for each new notification.
     * @description Receive email notifications once the event occurs (helper)
     */
    FREQUENCY_IMMEDIATE_DESCRIPTION = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.IMMEDIATE.DESCRIPTION',
    /**
     * @value Immediately
     * @description Receive email notifications once the event occurs (label)
     */
    FREQUENCY_IMMEDIATE_LABEL = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.IMMEDIATE.LABEL',
    /**
     * @value Display my activity on public profile
     */
    HISTORY_VISIBLE = 'USER_PROFILE_HISTORY_VISIBLE',
    /**
     * @value Display your activity history (posts, likes, etc.) in your profile page for all users.
     */
    HISTORY_VISIBLE_HELP = 'USER_PROFILE_HISTORY_VISIBLE_HELP',
    /**
     * @value You will find here connection options to other services if admins setup integrations
     */
    INTEGRATIONS_EMPTY_DESCRIPTION = 'USER_SETTINGS.INTEGRATIONS_EMPTY_DESCRIPTION',
    /**
     * @value There are no integrations
     */
    INTEGRATIONS_EMPTY_STATE = 'USER_SETTINGS.INTEGRATIONS_EMPTY_STATE',
    /**
     * @value Main language of the interface
     */
    MAIN_LANGUAGE = 'USER_PROFILE_MAIN_LANGUAGE',
    /**
     * @value My settings
     */
    MY_SETTINGS = 'MY_SETTINGS',
    /**
     * @value Integrations
     */
    NATIVE_INTEGRATIONS = 'NATIVE_INTEGRATIONS',
    /**
     * @value Notification types
     * @description Header of the table that allows the user to configure in-app and email notifications reception per notification type.
     */
    NOTIFICATION_PREFERENCES_TABLE_HEADER = 'NOTIFICATION.PREFERENCES.TABLE.HEADER',
    /**
     * @value New password
     */
    PASSWORD = 'USER_PROFILE_PASSWORD',
    /**
     * @value New passwords do not match
     */
    PASSWORD_DO_NOT_MATCH = 'USER_PROFILE_PASSWORD_DO_NOT_MATCH',
    /**
     * @value QR Code
     */
    QR_CODE = 'USER_SETTINGS.QR_CODE',
    /**
     * @value The code expires at: %TIME%
     */
    QR_CODE_EXPIRES = 'USER_SETTINGS.QR_CODE_EXPIRES',
    /**
     * @value This QR code contains your login information. Do not share it.
     */
    QR_CODE_WARNING = 'USER_SETTINGS.QR_CODE_WARNING',
    /**
     * @value Confirm password
     */
    REPASSWORD = 'USER_PROFILE_REPASSWORD',
    /**
     * @value Manage your account settings and preferences
     */
    SETTINGS_SUBTITLE = 'USER_SETTINGS.SUBTITLE',
    /**
     * @value Social Profiles
     */
    SOCIAL_PROFILES = 'SOCIAL_PROFILES',
    /**
     * @value Unsubscribe
     */
    UNSUBSCRIBE = 'USER_SETTINGS.UNSUBSCRIBE',
    /**
     * @value Unsubscribe from all emails
     */
    UNSUBSCRIBE_FROM_EMAIL = 'USER_SETTINGS.UNSUBSCRIBE_FROM_EMAIL',
    /**
     * @value You will no longer receive email notifications to %USER_EMAIL%.
     */
    UNSUBSCRIBE_MESSAGE_PART1 = 'USER_SETTINGS.UNSUBSCRIBE_MESSAGE_PART1',
    /**
     * @value You can manage types of notifications you receive in your profile settings.
     */
    UNSUBSCRIBE_MESSAGE_PART2 = 'USER_SETTINGS.UNSUBSCRIBE_MESSAGE_PART2',
    /**
     * @value Profile saved successfully
     */
    USER_PROFILE_SAVE_SUCCESS = 'USER_PROFILE_SAVE_SUCCESS',
}
/**
 * List of all the keys used to display the notification type description.
 * */
export enum NOTIFICATION_TYPE_DESC_KEYS {
    /**
     * @value Mention in an article
     * @description Option whether to receive a notfication when the user is mentionned in an article
     */
    ARTICLE_MENTION = 'NOTIFICATION.TYPE.ARTICLE.MENTION.DESCRIPTION',
    /**
     * @value New article published in a community you follow
     * @description An option that decides whether to receive a notification when an article is created in a community followed by the user.
     */
    ARTICLE_NEW = 'NOTIFICATION.TYPE.ARTICLE.NEW.DESCRIPTION',
    /**
     * @value Likes on your comments
     * @description Type of notification received when someone likes a comment you made
     */
    COMMENT_LIKE = 'NOTIFICATION.TYPE.COMMENT.LIKE.DESCRIPTION',
    /**
     * @value Mentions in a comment
     * @description Type of notification received when user is mentioned in a comment.
     */
    COMMENT_MENTION = 'NOTIFICATION.TYPE.COMMENT.MENTION.DESCRIPTION',
    /**
     * @value Mention in an article comment
     * @description An option that decides whether to receive a notification when a user is mentioned in an article comment
     */
    COMMENT_MENTION_ON_ARTICLE = 'NOTIFICATION.TYPE.COMMENT.MENTION.ON.ARTICLE.DESCRIPTION',
    /**
     * @value Mention in an event comment
     * @description An option that decides whether to receive a notification when a user is mentioned in an event comment
     */
    COMMENT_MENTION_ON_EVENT = 'NOTIFICATION.TYPE.COMMENT.MENTION.ON.EVENT.DESCRIPTION',
    /**
     * @value Comments on your content
     * @description Type of notification received when a user comments on your content.
     */
    COMMENT_NEW = 'NOTIFICATION.TYPE.COMMENT.NEW.DESCRIPTION',
    /**
     * @value Replies to your comments
     * @description Type of notification received when a user replies on one of your comments
     */
    COMMENT_REPLY = 'NOTIFICATION.TYPE.COMMENT.REPLY.DESCRIPTION',
    /**
     * @value Depublication of a comment following a report
     * @description Type of notification you receive when one of your comments have been unpublished following a report.
     */
    COMMENT_REPORT_ACCEPTED = 'NOTIFICATION.TYPE.COMMENT.REPORT.ACCEPTED.DESCRIPTION',
    /**
     * @value Report of a comment
     * @description Type of notification you receive when a comment has been reported.
     */
    COMMENT_REPORT_CREATED = 'NOTIFICATION.TYPE.COMMENT.REPORT.CREATED.DESCRIPTION',
    /**
     * @value Processing of a comment review
     * @description Type of notification you receive when one of your reports on a comment has been reviewed.
     */
    COMMENT_REPORT_REVIEWED = 'NOTIFICATION.TYPE.COMMENT.REPORT.REVIEWED.DESCRIPTION',
    /**
     * @value Extended services set up on a community you manage
     * @description Type of notification received when extended services on a community you manage are ready.
     */
    COMMUNITY_EXTENDED_SERVICE_MANAGEMENT = 'NOTIFICATION.TYPE.COMMUNITY.EXTENDED.SERVICE.MANAGEMENT.DESCRIPTION',
    /**
     * @value Requests to access a community you manage
     * @description Type of notification received when someone requests access to a community you manage
     */
    COMMUNITY_NEW_ACCESS_REQUEST = 'NOTIFICATION.TYPE.COMMUNITY.NEW.ACCESS.REQUEST.DESCRIPTION',
    /**
     * @value Approval of your request to access a community
     * @description Type of notification received when a community manager approves your request to join it
     */
    COMMUNITY_NEW_CREDENTIAL = 'NOTIFICATION.TYPE.COMMUNITY.NEW.CREDENTIAL.DESCRIPTION',
    /**
     * @value Content about to expire
     * @description Type of notification received when a piece of content you manage is about to reach its end of publication
     */
    CONTENT_EXPIRATION = 'NOTIFICATION.TYPE.CONTENT.EXPIRATION.DESCRIPTION',
    /**
     * @value Likes on your content
     * @description Type of notification received when someone likes your content
     */
    CONTENT_LIKE = 'NOTIFICATION.TYPE.CONTENT.LIKE.DESCRIPTION',
    /**
     * @value Mentions in a content
     */
    CONTENT_MENTION = 'NOTIFICATION.TYPE.CONTENT.MENTION.DESCRIPTION',
    /**
     * @value New content published
     * @description Type of notification received when new content has been published
     */
    CONTENT_NEW = 'NOTIFICATION.TYPE.CONTENT.NEW.DESCRIPTION',
    /**
     * @value Request for content publication refused
     * @description Type of notification received when a user refused to publish your content
     */
    CONTENT_REFUSED = 'NOTIFICATION.TYPE.CONTENT.REFUSED.DESCRIPTION',
    /**
     * @value Depublication of a content following a report
     * @description Type of notification you receive when one of your contents have been unpublished following a report.
     */
    CONTENT_REPORT_ACCEPTED = 'NOTIFICATION.TYPE.CONTENT.REPORT.ACCEPTED.DESCRIPTION',
    /**
     * @value Report of a content
     * @description Type of notification you receive when a content has been reported.
     */
    CONTENT_REPORT_CREATED = 'NOTIFICATION.TYPE.CONTENT.REPORT.CREATED.DESCRIPTION',
    /**
     * @value Processing of a content review
     * @description Type of notification you receive when one of your reports on a content has been reviewed.
     */
    CONTENT_REPORT_REVIEWED = 'NOTIFICATION.TYPE.CONTENT.REPORT.REVIEWED.DESCRIPTION',
    /**
     * @value Content updated
     * @description Type of notification received when a piece of content is updated
     */
    CONTENT_UPDATE = 'NOTIFICATION.TYPE.CONTENT.UPDATE.DESCRIPTION',
    /**
     * @value Request for content publication approved
     * @description Type of notification received when a content publication request has been approved
     */
    CONTENT_VALIDATED = 'NOTIFICATION.TYPE.CONTENT.VALIDATED.DESCRIPTION',
    /**
     * @value Request for content publication waiting for validation
     * @description Type of notification when someone requests your approval to publish new content
     */
    CONTENT_WORKFLOW = 'NOTIFICATION.TYPE.CONTENT.WORKFLOW.DESCRIPTION',
    /**
     * @value Notifications from business applications
     * @description Type of notification you receive when an external app creates new notifications
     */
    CUSTOM = 'NOTIFICATION.TYPE.CUSTOM.DESCRIPTION',
    /**
     * @value Event deleted
     * @description - Placeholder in a post indicating the event has been deleted
     * - One of the notification types in user Settings
     */
    EVENT_DELETED = 'EVENTS.DELETED',
    /**
     * @value Invitations to events
     * @description Description of the type of notification you receive when you are invited to an event.
     */
    EVENT_INVITATION_CREATED = 'NOTIFICATION.TYPE.EVENT.INVITATION.CREATED.DESCRIPTION',
    /**
     * @value Mention in an event
     * @description Option whether to receive a notification when the user is mentionned in an event
     */
    EVENT_MENTION = 'NOTIFICATION.TYPE.EVENT.MENTION.DESCRIPTION',
    /**
     * @value New event published in a community you follow
     * @description An option that decides whether to receive a notification when an event is created in a community followed by the user.
     */
    EVENT_NEW = 'NOTIFICATION.TYPE.EVENT.NEW.DESCRIPTION',
    EVENT_REGISTRATION_REQUEST = 'NOTIFICATION.TYPE.EVENT.REGISTRATION.REQUEST.DESCRIPTION',
    /**
     * @value Event Response
     * @description An option that decides whether to receive a notification when an event is created in a community followed by the user.
     */
    EVENT_REGISTRATION_RESPONSE = 'NOTIFICATION.TYPE.EVENT.REGISTRATION.RESPONSE.DESCRIPTION',
    /**
     * @value Event updated
     * @description Description of the type of notification you receive when an event you are invited to, is updated
     */
    EVENT_UPDATED = 'NOTIFICATION.TYPE.EVENT.UPDATED.DESCRIPTION',
    /**
     * @value Congratulation for a successful training
     */
    LEARNING_CONGRATULATION = 'NOTIFICATION.TYPE.LEARNING.CONGRATULATION.DESCRIPTION',
    /**
     * @value Enrollment in a learning
     */
    LEARNING_COURSE_BEGINNING = 'NOTIFICATION.TYPE.LEARNING.COURSE.BEGINNING.DESCRIPTION',
    /**
     * @value Reminder to complete a required training (last day)
     */
    LEARNING_COURSE_ENDING_SOON = 'NOTIFICATION.TYPE.LEARNING.COURSE.ENDING.SOON.DESCRIPTION',
    /**
     * @value Reminder to complete a required training (7 days left)
     */
    LEARNING_COURSE_ENDING_TODAY = 'NOTIFICATION.TYPE.LEARNING.COURSE.ENDING.TODAY.DESCRIPTION',
    /**
     * @value Challenge to a learning activity duel
     */
    LEARNING_DUEL = 'NOTIFICATION.TYPE.LEARNING.DUEL.DESCRIPTION',
    /**
     * @value Reminder to do a training
     */
    LEARNING_REMINDER = 'NOTIFICATION.TYPE.LEARNING.REMINDER.DESCRIPTION',
    /**
     * @value Mentions in a post
     * @description Type of notification received when someone mentions you in a post
     */
    POST_MENTION = 'NOTIFICATION.TYPE.POST.MENTION.DESCRIPTION',
    /**
     * @value New posts in a community you follow
     * @description Type of notification received when a new post is available in a community you follow
     */
    POST_NEW = 'NOTIFICATION.TYPE.POST.NEW.DESCRIPTION',
    /**
     * @value Deletion of a post following a report
     * @description Type of notification you receive when one of your posts have been deleted following a report.
     */
    POST_REPORT_ACCEPTED = 'NOTIFICATION.TYPE.POST.REPORT.ACCEPTED.DESCRIPTION',
    /**
     * @value Report of a post
     * @description Type of notification you receive when a post has been reported.
     */
    POST_REPORT_CREATED = 'NOTIFICATION.TYPE.POST.REPORT.CREATED.DESCRIPTION',
    /**
     * @value Processing of a post review
     * @description Type of notification you receive when one of your reports on a post has been reviewed.
     */
    POST_REPORT_REVIEWED = 'NOTIFICATION.TYPE.POST.REPORT.REVIEWED.DESCRIPTION',
    /**
     * @value Status of an Idea post updated
     * @description Type of notification you receive when a post's status is updated
     */
    POST_STATUS_UPDATE = 'NOTIFICATION.TYPE.POST.STATUS.UPDATE.DESCRIPTION',
    /**
     * @value Post updated in a community you follow
     * @description Type of notification you receive when a post is updated in a community you follow
     */
    POST_UPDATE = 'NOTIFICATION.TYPE.POST.UPDATE.DESCRIPTION',
    /**
     * @value Likes on your replies
     * @description Type of notification you receive when one of your replies to a comment is liked
     */
    REPLY_LIKE = 'NOTIFICATION.TYPE.REPLY.LIKE.DESCRIPTION',
    /**
     * @value New shareable content in a Social Advocacy program
     * @description Type of notification you receive when new shareable content is available in a social advocacy program
     */
    SOCIAL_ADVOCACY_NEW_SHAREABLE_CONTENT = 'NOTIFICATION.TYPE.SOCIAL.ADVOCACY.NEW.SHAREABLE.CONTENT.DESCRIPTION',
}
/** Override like kinds key's with reaction when the feature flag is enabled. */
export enum NOTIFICATION_TYPE_DESC_KEYS_WITH_REACTIONS {
    /**
     * @value Reactions on your comments
     * @description Type of notification received when someone reacted to a comment you made
     */
    COMMENT_LIKE = 'NOTIFICATION.TYPE.COMMENT.REACTION.DESCRIPTION',
    /**
     * @value Reactions on your content
     * @description Type of notification received when someone reacted to your content
     */
    CONTENT_LIKE = 'NOTIFICATION.TYPE.CONTENT.REACTION.DESCRIPTION',
    /**
     * @value Reactions on your replies
     * @description Type of notification you receive when one of your replies to a comment is reacted to
     */
    REPLY_LIKE = 'NOTIFICATION.TYPE.REPLY.REACTION.DESCRIPTION',
}
export const getNotificationLabelByKind = (kind: string) => `NOTIFICATION.TYPE.${kind.replace(/_/g, '.')}.DESCRIPTION`;
